// TODO refactor
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import './NavLinks.css';

export default function NavLinks() {
  const { isAuthenticated, logout } = useAuth();

  return (
    <ul className="nav-links">
      <li>
        {isAuthenticated ? (
          <a href="/Frontend/public" onClick={() => logout()} className="bordered-navlink">
            LOG OUT
          </a>
        ) : (
          <div>
            <NavLink to="/login" className="basic-navlink">
              LOG IN
            </NavLink>
          </div>
        )}
      </li>
    </ul>
  );
}
